import { useEffect, useState } from "react"
import { Box, BoxBackGround } from "../common/Box";
import { GET_USER_INFO_ERROR } from "../common/Constant/Constant";
import { LoadingIcon } from "../common/LoadingIcon/LoadingIcon";
import { Text } from "../common/Text";
import { findUserByPrsnlId, UserInfo } from "../features/UserSearch";


type Props = {
  prsnl_id: string;
}

export const UserInfoView: React.FC<Props> = (props) => {
  console.log(`prsnl_id: ${props.prsnl_id}`);

  useEffect(() => {
    findUser(props.prsnl_id);
  }, [])
  
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [errorMessage, setErrorMessage] = useState<string>();

  const findUser = async (prsnlId:string) => {
    try{
      setUserInfo(await findUserByPrsnlId(prsnlId));
    } catch (e) {
      setErrorMessage(GET_USER_INFO_ERROR);
    }
  }
  // エラーメッセージがある場合は表示する
  if (errorMessage) {
    return (
      <Box background={BoxBackGround.ALERT}>{errorMessage}</Box>
    )
  }

  // userInfo 取得前はローディングアイコンの表示をする
  if (!userInfo) {
    return (
      <Box background={BoxBackGround.FILL}>
        <LoadingIcon />
      </Box>
    )
  }

  // userInfo 表示
  return (
    <Box background={BoxBackGround.FILL}>
      <Text
        textItems={[
          {
            leadSentence: `会員氏名（漢字）： ${userInfo.usr_namej}`,
          },
        ]}
        adjust={{ mb: 8 }}
      />
      <Text
        textItems={[
          {
            leadSentence: `ユーザーID(Web認証ID)： ${userInfo.auth_id}`,
          },
        ]}
        adjust={{ mb: 8 }}
      />
    </Box>
  );
}
